import { PropsWithChildren } from 'react';
import styled from 'styled-components';
import { Collapsible, CollapsibleProps } from './Collapsible';
import { FlexColumn } from '../Flex';

const Body = styled(FlexColumn)` ${({ theme }) => `
  gap: ${theme.padding[4]};
  padding-left: ${theme.padding[4]};
  padding-right: ${theme.padding[4]};
`}`;

export function PaddedCollapsible(props: PropsWithChildren<Readonly<CollapsibleProps>>) {
  const { children } = props;

  return (
    <Collapsible {...props}><Body>{children}</Body></Collapsible>
  );
}
